import { useLang } from 'hooks/lang';

import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { TaskIcon } from 'components/Icons';

import { useProjectById } from 'providers/Project';
import { useRecruitmentModal } from './context';

import { listGet } from 'utils/array';
import { formatDate } from 'utils/date';

export function RecruitmentTaskDate() {
  const { t } = useLang();

  const { recruitment } = useRecruitmentModal();

  const project = useProjectById(recruitment.id);

  const task = listGet(project?.tasks ?? [], recruitment.task);

  if (!task) return null;

  return (
    <PropertyWithIcon
      gap="3"
      icon={<TaskIcon size={20} color="currentColor" />}
      name={t('task-expected-by')}
      value={task.expectedDate ? formatDate(task.expectedDate) : 'N/A'}
    />
  );
}
